module.exports = __webpack_public_path__ + "img/hr-curved-rail-vertical-right-bottom-stone-path-remnants.3281f585.png";